import {RepositoryRunners as RepositoryRunnersView} from '@github-ui/actions-runners'
import {useParams, useSearchParams} from '@github-ui/react-router'
import {useAnalytics} from '@github-ui/use-analytics'
import {useEffect} from 'react'

export function RepositoryRunners() {
  const {owner = '', repo = ''} = useParams()
  const [searchParams] = useSearchParams()
  const {sendAnalyticsEvent} = useAnalytics()
  const fetchRunnersBasePath = `/${owner}/${repo}/actions/runners`
  const selectedTab = searchParams.get('tab') === 'self-hosted' ? 'self-hosted' : 'github-hosted'

  useEffect(() => {
    sendAnalyticsEvent('view_rendered', undefined, {
      name: `repository_runners/${selectedTab.replace('-', '_')}`,
    })
  }, [selectedTab, sendAnalyticsEvent])

  return (
    <RepositoryRunnersView
      selectedTab={selectedTab}
      githubHostedRunnersPath={fetchRunnersBasePath}
      selfHostedRunnersPath={`${fetchRunnersBasePath}?tab=self-hosted`}
      fetchRunnersBasePath={fetchRunnersBasePath}
      softNavigationEnabled
    />
  )
}
